module.exports = __webpack_public_path__ + "media/images/landing_page/mes-1b3f7f141a9fe505482dd2a475f3dbc5.jpg";